import React, {useState} from "react";
import {Tooltip, Popover, Typography, Grid, Avatar, Box} from "@material-ui/core";

export default function DietaryPreferences({dietaryPreferences = [], style = {}}) {
	const [anchorEl, setAnchorEl] = useState(null);
	const [selected, setSelected] = useState(null);

	const handleClick = (event, item) => {
		setAnchorEl(event.currentTarget);
		setSelected(item);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setSelected(null);
	};

	const open = Boolean(anchorEl);

	if (!dietaryPreferences?.length) return null;

	return (
		<>
			<Grid container spacing={1} style={style}>
				{dietaryPreferences.map((d, index) => (
					<Grid item key={index}>
						<Tooltip title={d.name} arrow>
							<img
								src={d.image}
								alt={d.name}
								onClick={(e) => handleClick(e, d)}
								style={{
									width: "100%",
									minWidth: 60,
									height: 60,
									objectFit: "contain",
									cursor: "pointer",
									transition: "0.2s",
								}}
							/>
						</Tooltip>
					</Grid>
				))}
			</Grid>

			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{vertical: "top", horizontal: "center"}}
				transformOrigin={{vertical: "bottom", horizontal: "center"}}
			>
				{selected && (
					<Box
						style={{
							padding: 16,
							borderRadius: 8,
							maxWidth: 450,
							textAlign: "center",
							// boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
						}}
					>
						<img
							src={selected.image}
							alt={selected.name}
							style={{
								width: "100%",
								height: 90,
								objectFit: "contain",
								margin: "0 auto 8px",
							}}
						/>
						<Typography variant="subtitle1" style={{fontWeight: "bold"}}>
							{selected.name}
						</Typography>
						<Typography variant="body2" color="textSecondary" style={{marginTop: 4}}>
							{selected.description || "No description available."}
						</Typography>
						<Typography variant="body2" color="textSecondary" style={{marginTop: 2}}>
							{"Check all our"} <a href={`/search/${selected.name}`} target="_blank" style={{color: "#9cc54b"}}
							                     rel="noopener noreferrer">{selected.name}</a> products.
						</Typography>
					</Box>
				)}
			</Popover>
		</>
	);
}
